export default "__VITE_PUBLIC_ASSET__1edee01f__"